import React from 'react'
import { WidgetGuard } from 'features/types'
import { TopicNotSelectedGuard } from 'components/widget/share/guards'

const PreSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>{children}</TopicNotSelectedGuard>
)

export default PreSearchDataGuards
